var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8003 12.4316L18.4876 8.46321L4.22579 0L4.22579 7.93671L1.00012 6.02253L0.00012279 5.42911L0.000122741 6.59193L0.00012212 21.1927L0.00012207 22.3555L1.00012 21.7621L13.2821 14.4737L14.2619 13.8923L13.2821 13.3109L11.8003 12.4316ZM4.22579 9.09952L4.22579 16.9264L10.8205 13.013L12.3024 13.8923L1.00012 20.5993L1.00012 7.18535L4.22579 9.09952Z",
    fill: "#235CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.e662e257cac2ea93ee17f2d97f63a6c3.svg";
export { ForwardRef as ReactComponent };